export const availableTypeList = [
  { value: 'Persend' },
  { value: 'Internet' },
  { value: 'Approved' },
]
